/**
 * Par de `exigirTenant` para as rotas por organização (spec 2026-10-23 §5.3): sem
 * organização a mutação recusa antes do HTTP, em vez de mandar
 * `/organizations/undefined/...`.
 */
export function exigirOrganizacao(orgId: number | undefined | null): number {
  if (orgId == null) throw new Error('Nenhuma organização disponível para esta operação')
  return orgId
}
